import { Controller } from "@hotwired/stimulus"

// Always keep one blank trailing store-link row so admins can add multiple links
// without saving between each.
export default class extends Controller {
  static targets = ["list", "template", "row"]

  connect() {
    this.ensureBlankRow()
  }

  changed() {
    this.ensureBlankRow()
  }

  remove(event) {
    event.preventDefault()
    event.currentTarget.closest('[data-nested-links-target="row"]')?.remove()
    if (this.rowTargets.length === 0) {
      this.addRow()
      return
    }
    this.ensureBlankRow()
  }

  ensureBlankRow() {
    const last = this.rowTargets[this.rowTargets.length - 1]
    if (!last || this.rowFilled(last)) {
      this.addRow()
    }
  }

  addRow() {
    const html = this.templateTarget.innerHTML.replaceAll("NEW_RECORD", Date.now().toString())
    this.listTarget.insertAdjacentHTML("beforeend", html)
  }

  rowFilled(row) {
    return Array.from(row.querySelectorAll("input, select")).some((el) => {
      if (el.type === "checkbox") return false
      return Boolean(el.value?.trim())
    })
  }
}
